export enum SortByType {
	Name = "Name",
	Severity = "Severity",
}
